import { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Task, Category, GanttData } from '../types';

const defaultCategories: Category[] = [
  { id: '1', name: 'Development', color: '#3B82F6' },
  { id: '2', name: 'Design', color: '#10B981' },
  { id: '3', name: 'Testing', color: '#F59E0B' },
  { id: '4', name: 'Marketing', color: '#EF4444' },
];

const defaultTasks: Task[] = [
  {
    id: '1',
    name: 'AUSEA Company Structure',
    startDate: new Date('2025-11-01'),
    endDate: new Date('2025-11-30'),
    categoryId: '1',
    dependencies: [],
    progress: 100,
    description: 'Initial project planning and requirements gathering'
  },
  {
    id: '2',
    name: 'AUSEA Website',
    startDate: new Date('2025-11-01'),
    endDate: new Date('2025-11-30'),
    categoryId: '2',
    dependencies: ['1'],
    progress: 75,
    description: 'Complete website development project'
  },
  {
    id: '2-1',
    name: 'Content Collection',
    startDate: new Date('2025-11-01'),
    endDate: new Date('2025-11-15'),
    categoryId: '2',
    parentId: '2',
    dependencies: [],
    progress: 90,
    description: 'Gather and organize all website content'
  },
  {
    id: '2-2',
    name: 'Frontend Development',
    startDate: new Date('2025-11-01'),
    endDate: new Date('2025-11-20'),
    categoryId: '1',
    parentId: '2',
    dependencies: [],
    progress: 80,
    description: 'Develop user interface and user experience'
  },
  {
    id: '2-3',
    name: 'Backend Development',
    startDate: new Date('2025-11-15'),
    endDate: new Date('2025-11-30'),
    categoryId: '1',
    parentId: '2',
    dependencies: ['2-1'],
    progress: 60,
    description: 'Develop server-side functionality and database'
  },
  {
    id: '3',
    name: 'Content Marketing',
    startDate: new Date('2025-12-01'),
    endDate: new Date('2026-02-01'),
    categoryId: '4',
    dependencies: ['2'],
    progress: 45,
    description: 'Comprehensive content marketing campaign'
  },
  {
    id: '3-1',
    name: 'Video Making',
    startDate: new Date('2025-12-01'),
    endDate: new Date('2025-12-15'),
    categoryId: '4',
    parentId: '3',
    dependencies: [],
    progress: 30,
    description: 'Create promotional and educational videos'
  },
  {
    id: '3-2',
    name: 'Little Red Book',
    startDate: new Date('2025-12-15'),
    endDate: new Date('2026-01-01'),
    categoryId: '4',
    parentId: '3',
    dependencies: ['3-1'],
    progress: 20,
    description: 'Social media marketing on Little Red Book platform'
  },
  {
    id: '3-3',
    name: 'YouTube',
    startDate: new Date('2025-12-15'),
    endDate: new Date('2026-01-01'),
    categoryId: '4',
    parentId: '3',
    dependencies: ['3-1'],
    progress: 15,
    description: 'YouTube channel content and marketing'
  },
  {
    id: '3-4',
    name: 'Marketing Materials',
    startDate: new Date('2025-12-01'),
    endDate: new Date('2026-01-15'),
    categoryId: '4',
    parentId: '3',
    dependencies: [],
    progress: 25,
    description: 'Design and create marketing materials and collateral'
  },
  {
    id: '4',
    name: 'Ashwood Showroom',
    startDate: new Date('2026-01-15'),
    endDate: new Date('2026-03-15'),
    categoryId: '1',
    dependencies: ['1'],
    progress: 30,
    description: 'Complete showroom renovation and setup'
  },
  {
    id: '5',
    name: 'Office Refurbishment',
    startDate: new Date('2026-01-15'),
    endDate: new Date('2026-02-15'),
    categoryId: '1',
    parentId: '4',
    dependencies: [],
    progress: 80,
    description: 'Renovate and refurbish office spaces'
  },
  {
    id: '6',
    name: 'Kitchen Refurbishment',
    startDate: new Date('2026-02-01'),
    endDate: new Date('2026-03-01'),
    categoryId: '1',
    parentId: '4',
    dependencies: ['5'],
    progress: 20,
    description: 'Complete kitchen renovation and equipment installation'
  },
  {
    id: '7',
    name: 'Signage',
    startDate: new Date('2026-02-15'),
    endDate: new Date('2026-03-15'),
    categoryId: '1',
    parentId: '4',
    dependencies: ['5'],
    progress: 0,
    description: 'Design and install showroom signage'
  },
  {
    id: '8',
    name: '892 Hampton St Brighton',
    startDate: new Date('2026-02-15'),
    endDate: new Date('2026-10-15'),
    categoryId: '1',
    dependencies: [],
    progress: 0,
    description: 'Complete construction project at Hampton Street Brighton'
  },
  {
    id: '8-1',
    name: 'Design & Permit',
    startDate: new Date('2026-02-15'),
    endDate: new Date('2026-05-15'),
    categoryId: '2',
    parentId: '8',
    dependencies: [],
    progress: 0,
    description: 'Architectural design and permit approval process'
  },
  {
    id: '8-2',
    name: 'Construction',
    startDate: new Date('2026-05-15'),
    endDate: new Date('2026-10-15'),
    categoryId: '1',
    parentId: '8',
    dependencies: ['8-1'],
    progress: 0,
    description: 'Main construction phase of the project'
  },
  {
    id: '9',
    name: 'Ashwood Project Marketing',
    startDate: new Date('2026-02-15'),
    endDate: new Date('2026-05-15'),
    categoryId: '4',
    dependencies: [],
    progress: 0,
    description: 'Marketing campaign for Ashwood project'
  },
  {
    id: '9-1',
    name: 'Deal Structuring',
    startDate: new Date('2026-02-15'),
    endDate: new Date('2026-03-01'),
    categoryId: '4',
    parentId: '9',
    dependencies: [],
    progress: 0,
    description: 'Structure and finalize deal terms and agreements'
  },
  {
    id: '9-2',
    name: 'Marketing Materials',
    startDate: new Date('2026-03-01'),
    endDate: new Date('2026-03-15'),
    categoryId: '4',
    parentId: '9',
    dependencies: ['9-1'],
    progress: 0,
    description: 'Create marketing materials and promotional content'
  },
  {
    id: '9-3',
    name: 'Marketing Campaign',
    startDate: new Date('2026-03-15'),
    endDate: new Date('2026-05-15'),
    categoryId: '4',
    parentId: '9',
    dependencies: ['9-2'],
    progress: 0,
    description: 'Execute comprehensive marketing campaign'
  }
];

export const useGanttData = () => {
  const [data, setData] = useState<GanttData>({
    tasks: defaultTasks,
    categories: defaultCategories,
  });

  const addTask = useCallback((task: Omit<Task, 'id'>) => {
    const newTask: Task = {
      ...task,
      id: uuidv4(),
    };
    setData(prev => ({
      ...prev,
      tasks: [...prev.tasks, newTask],
    }));
  }, []);

  const updateTask = useCallback((taskId: string, updates: Partial<Task>) => {
    setData(prev => ({
      ...prev,
      tasks: prev.tasks.map(task =>
        task.id === taskId ? { ...task, ...updates } : task
      ),
    }));
  }, []);

  const deleteTask = useCallback((taskId: string) => {
    setData(prev => ({
      ...prev,
      tasks: prev.tasks.filter(task => task.id !== taskId && task.parentId !== taskId),
    }));
  }, []);

  const addCategory = useCallback((category: Omit<Category, 'id'>) => {
    const newCategory: Category = {
      ...category,
      id: uuidv4(),
    };
    setData(prev => ({
      ...prev,
      categories: [...prev.categories, newCategory],
    }));
  }, []);

  const updateCategory = useCallback((categoryId: string, updates: Partial<Category>) => {
    setData(prev => ({
      ...prev,
      categories: prev.categories.map(category =>
        category.id === categoryId ? { ...category, ...updates } : category
      ),
    }));
  }, []);

  const deleteCategory = useCallback((categoryId: string) => {
    setData(prev => ({
      ...prev,
      categories: prev.categories.filter(category => category.id !== categoryId),
    }));
  }, []);

  return {
    data,
    addTask,
    updateTask,
    deleteTask,
    addCategory,
    updateCategory,
    deleteCategory,
  };
};